module.exports = __webpack_public_path__ + "static/img/8247bd1f1d229d84e509682fd1fabaff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_49.png
// module id = SkxI
// module chunks = 1